"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextualTransformer = void 0;
var ContextualTransformer = /** @class */ (function () {
    function ContextualTransformer(context) {
        this.context = context;
    }
    /**
     * Трансформирует фильтры настроек для браузера.
     *
     * Не мутирует настройку.
     * Возвращает новую настройку, если были изменения.
     *
     * @param {ISetting} setting - настройка
     * @returns {ISetting}
     * @memberof SettingTransformer
     */
    ContextualTransformer.prototype.transform = function (setting) {
        var filter = setting.filter;
        if (filter.unique_by_request) {
            filter = __assign(__assign({}, filter), { 'request-id': this.context.requestId });
        }
        if (filter === setting.filter) {
            return setting;
        }
        return __assign(__assign({}, setting), { filter: filter });
    };
    return ContextualTransformer;
}());
exports.ContextualTransformer = ContextualTransformer;
//# sourceMappingURL=ContextualTransformer.js.map